<template>
  <section class="pb-8" id="contact">
    <v-container fluid v-if="school">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Contact Us</h1>
              <h5 class="font-weight-light mt-3">
                Feel free to contact us regarding any enquiry you may have and
                our friendly admins will get back to you as soon as possible.
              </h5>
              <h5 class="font-weight-light mt-3">
                Thanks in advance for reaching out to us.
              </h5>
              <h4 class="font-weight-light mt-3">
                Telephone: {{ school.sch_tel }}
              </h4>
              <h4 class="font-weight-light">
                Address: {{ school.physical_address }}
              </h4>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  v-model="contactName"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="contactEmail"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-textarea
                  :rules="textAreaRules"
                  label="Message"
                  required
                  v-model="contactBody"
                />

                <v-btn
                  :disabled="!valid"
                  color="teal"
                  :dark="valid"
                  rounded
                  block
                  class="mt-3"
                  @click="submitContact"
                >
                  Submit
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg" />
    </div>
    <v-snackbar
      v-model="snackbar.enabled"
      timeout="3000"
      right
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.enabled = false">
          Fetching...
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
</style>

<script>
import axios from "@/plugins/axios";
// import {db} from '@/main'

export default {
  props: {
    school: {
      default: null,
    },
  },
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    contactName: "",
    contactEmail: "",
    nameRules: [
      (v) => !!v || "Name field is Required!",
      (v) => (v && v.length <= 100) || "Name must be 100 or less Characters",
    ],

    emailRules: [
      (v) => !!v || "Email field is Required!",
      (v) => /.+@.+\..+/.test(v) || "Email must be a valid email",
    ],
    contactBody: "",
    textAreaRules: [
      (v) => !!v || "Message field is Required!",
      (v) =>
        (v && v.length <= 255) ||
        "The message fiels must be less than 255 characters!",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
  }),
  methods: {
    submitContact() {
      this.$store.commit("setLoader", true);
      if (
        this.contactName != "" &&
        this.contactEmail != "" &&
        this.contactBody != ""
      ) {
        axios
          .postData("/submit-contact-form-to-school", {
            emis: this.getUserSchool.emis,
            name: this.contactName,
            email: this.contactEmail,
            subject: "Website Enquiry",
            body: this.contactBody,
          })
          .then((response) => {
            this.$store.commit("setLoader", false);
            if (response === "success") {
              this.$toast.success("Form Submitted Successfully!");
              alert("Form Submitted Successfully!");
            } else {
              this.$toast.error("Oops, Something Went Wrong!");
              alert("Oops, Something Went Wrong!");
            }
          });
      } else {
        this.$toast.warning("All Contact Form Fields are required!");
        alert("All Contact Form Fields are required");
      }
    },
  },
};
</script>
